// extracted by mini-css-extract-plugin
export var cardContainer = "_o6-0";
export var cardHeader = "_o6-2";
export var collapsedState = "_o6-3";
export var dragHandle = "_o6-5";
export var dragHandleIcon = "_o6-6";
export var dragging = "_o6-1";
export var titleArea = "_o6-4";